import { render, staticRenderFns } from "./PublicTRDA.vue?vue&type=template&id=405f3151&"
import script from "./PublicTRDA.vue?vue&type=script&lang=ts&"
export * from "./PublicTRDA.vue?vue&type=script&lang=ts&"
import style0 from "./PublicTRDA.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports